// extracted by mini-css-extract-plugin
export default {"wrapper":"TableTwoTextarea_wrapper__Iy-On","input":"TableTwoTextarea_input__9M9ZJ","content":"TableTwoTextarea_content__ejdyY"};